export const setImgWidthAndHeight = (width: number, querySelector: string) => {
  const imgArr: NodeListOf<HTMLImageElement> =
    document.querySelectorAll(querySelector);
  // console.log('=========imgArr:', querySelector, imgArr)
  if (imgArr && imgArr.length > 0) {
    imgArr.forEach((item) => {
      let w = Number(item.getAttribute("width") || item.clientWidth);
      const h = Number(item.getAttribute("height") || item.clientHeight);
      if (w > width) {
        const s = Number((width / w).toFixed(2));
        item.style.height = `${(s * h).toFixed(2)}px`;
      }
    });
  }
};

export const downlodFile = (url: string, name: string) => {
  fetch(url, {
    mode: "cors",
    cache: "no-store",
  })
    .then((res) => {
      return res.blob();
    })
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = `${blobUrl}`;
      a.download = name;
      a.click();
    });
};

export const isH5 = () => {
  const userAgent = navigator.userAgent;
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  );
};
